import type React from 'react';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { useIOR } from '../../hooks/use-ior';
import Address from '../address';
import type { CustomsIOR } from '../customs-declarations/types';

import style from './ior-dropdown.module.css';

interface IORDropdownProps {
  importerOfRecord?: CustomsIOR | null;
  updateImporterOfRecord: (ior: CustomsIOR) => void;
  placeholder?: string;
}

export const IORDropdown: React.FC<IORDropdownProps> = ({ importerOfRecord = null, updateImporterOfRecord, placeholder = '' }) => {
  const { activeIORs } = useIOR();
  return (
    <DropdownMenu
      className={style.dropdown}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      value={importerOfRecord?.id ?? ''}
      variant='form'
    >
      <DropdownMenuToggler className={style.dropdown} testId='customs-widget-ior-dropdown'>
        {importerOfRecord?.isActive ? importerOfRecord.name : placeholder}
      </DropdownMenuToggler>
      {activeIORs.map((iorOption) => (
        <DropdownMenuItem
          key={iorOption?.id}
          onClick={() => updateImporterOfRecord(iorOption)}
          selected={importerOfRecord?.id === iorOption?.id}
        >
          <Address address={{ ...iorOption }} />
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
